import { normalizeLanguageCode } from "@/lib/languages";
import { getServerTemplateConfig } from "@/lib/serverTemplateDetection";

/**
 * Locale BCP 47 para <html lang> / og:locale / user_language persistido.
 *
 * Reglas:
 *   - Si i18n ya trae región (ej. "es-AR", "en-US", "pt-BR") → se respeta tal cual.
 *   - Si i18n trae solo base (ej. "es", "en") → se enriquece con la región del Worker
 *     (__TEMPLATE_CONFIG__.language) cuando la base coincide; si no, se usan los
 *     defaults estándar ("es" sin región para no inventar, "en-US" como neutro).
 *
 * NO se re-deriva geo: el Worker decidió la región, acá solo se completa el formato.
 */
export function getEffectiveSiteLanguage(i18nLanguage: string | undefined): string {
  const raw = (i18nLanguage || "es").trim();
  if (raw.includes("-")) return raw;

  const supportedBase = normalizeLanguageCode(raw);

  if (typeof window !== "undefined") {
    const workerLang = getServerTemplateConfig()?.language?.trim();
    if (workerLang && workerLang.toLowerCase().startsWith(`${supportedBase}-`)) {
      return workerLang;
    }
  }

  if (supportedBase === "en") return "en-US";
  return supportedBase;
}
